import EngineModule from '../../../EngineModule';
import {
	NS as StandingCustomerModeNS
}                   from '../../../components/customers/standing/StandingCustomerMode/StandingCustomerMode';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-customerMode',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', /* Local ecs */ 'sam1_12345' ],
	insertionPath :    'K',
	generateComponentConfiguration() : StandingCustomerModeNS.Configuration {
		return {};
	},
	async initialize() {

	}
});
